export default "__VITE_ASSET__DxgwVNFe__"